var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agent-empty"},[_c('img',{attrs:{"src":require("@/assets/images/agent/none.png"),"alt":""}}),_vm._v(" "),(_vm.msg)?_c('div',{staticClass:"empty-msg"},[_vm._v(_vm._s(_vm.msg))]):_vm._e(),_vm._v(" "),(_vm.desc)?_c('div',{staticClass:"empty-desc"},[_vm._v(_vm._s(_vm.desc))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }